import { render, staticRenderFns } from "./addproduct.vue?vue&type=template&id=65e655af&scoped=true&"
import script from "./addproduct.vue?vue&type=script&lang=js&"
export * from "./addproduct.vue?vue&type=script&lang=js&"
import style0 from "./addproduct.vue?vue&type=style&index=0&id=65e655af&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65e655af",
  null
  
)

export default component.exports